import { AuthenticationService } from '../../../../services/auth-service';
import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../services/navigation-service';
import { ColaboradoresService } from '../../../../services/colaboradores-service';
import { DialogsService } from '../../../../services/dialogs-service';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  PATH_BUSCADOR,
  PATH_BUSCADOR_COLABORADORES,
  PATH_COLABORADOR_DETAIL
} from '../../../../navigation/navigation.module';
import { TableDataSource } from '../../../../utils';

@Component({
  selector: 'app-colaboradores-list',
  templateUrl: './colaboradores-list.component.html',
  styleUrls: ['./colaboradores-list.component.scss']
})
export class ColaboradoresListComponent implements OnInit, AfterViewInit, OnDestroy {

  public VIEW_MODES = {
    RED: 'red',
    TODOS: 'todos'
  };

  viewMode = this.VIEW_MODES.RED;

  colaboradoresSubject$ = new BehaviorSubject<any[]>([]);
  colaboradoresDataSource = new TableDataSource(this.colaboradoresSubject$);
  colaboradoresDisplayedColumns = ['fullName', 'lastConnectedTime', 'actions'];
  colaboradoresResponseData = [];
  colaboradoresPage = 0;

  colaboradoresMiRedSubject$ = new BehaviorSubject<any[]>([]);
  colaboradoresMiRedDataSource = new TableDataSource(this.colaboradoresMiRedSubject$);
  colaboradoresMiRedDisplayedColumns = ['fullName', 'lastConnectedTime', 'actions'];
  colaboradoresMiRedResponseData = [];

  private todosCalled: boolean = false;

  private scrollSubscriber;

  selectedTabIndex = 0;

  constructor(private navigationService: NavigationService,
              private colaboradoresService: ColaboradoresService,
              private router: Router,
              private dialogsService: DialogsService,
              private authService: AuthenticationService,
              private route: ActivatedRoute,
              private location: Location) { }

  ngOnInit() {
    this.loadData();
  }

  loadData(){
    switch (this.viewMode) {
      case this.VIEW_MODES.RED:
        if (this.colaboradoresMiRedSubject$.getValue().length <= 0) {
          this.loadColaboradoresMiRed();
        }
        break;
      case this.VIEW_MODES.TODOS:
        if (!this.todosCalled) {
          this.loadColaboradores();
        }
        break;
      default:
        this.loadColaboradoresMiRed();
    }
  }

  loadColaboradores(page?: number) {
    this.todosCalled = true;
    this.colaboradoresService.getColaboradores(page)
      .subscribe( data => {
        this.colaboradoresResponseData = [ ...this.colaboradoresResponseData, ...data ];
        this.colaboradoresSubject$.next(this.colaboradoresResponseData);
      });
  }

  loadColaboradoresMiRed() {
    this.colaboradoresService.getColaboradoresMiRed()
      .subscribe( data => this.colaboradoresMiRedSubject$.next(data));
  }

  showNewConsignaDialog(colaborador){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', colaborador, null);
  }

  public showNewColaboradorDialog(){
    this.dialogsService.showNewColaboradorDialog()
      .subscribe( () => {
        this.resetColaboradoresLists();
      });
  }

  onColaboradorSelected(colaborador){
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.UserId]);
  }

  showEditColaboradorDialog(colaborador){
    this.dialogsService.showNewColaboradorDialog(
      colaborador
    ).subscribe( () => {
      this.resetColaboradoresLists();
    });
  }

  resetColaboradoresLists() {
    this.colaboradoresPage = 0;
    this.colaboradoresResponseData = [];
    this.colaboradoresMiRedResponseData = [];
    this.todosCalled = true;
    this.loadColaboradoresMiRed();
    this.loadColaboradores(0);
  }

  public ngAfterViewInit(): void {
    const content = document.querySelector('.mat-drawer-content');

    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        const max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7 && this.viewMode === this.VIEW_MODES.TODOS){
          this.colaboradoresPage ++;
          this.loadColaboradores(this.colaboradoresPage);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  changeViewMode(viewMode) {
    this.viewMode = viewMode;
    switch (viewMode) {
      case this.VIEW_MODES.RED:
        this.selectedTabIndex = 0;
        break;
      case this.VIEW_MODES.TODOS:
        this.selectedTabIndex = 1;
        break;
    }
    this.loadData();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/colaboradores/colaboradores-list/colaboradores-list.component.ts